/* global require console */
import Vue from "vue";
import $ from "jquery";

import { trans } from "common/translate";

import "./zippy.js";
import "./tab-content.js";
import "./tab-button.js";
import "./discussion.js";
import "./publications.js";

export default Vue.component("tablist", {
  props: [ "publications", "about", "notes", "manuscriptId" ],

  data() {
    return {
      mobileTabsOpen: [], // Enumerate the tabs open on mobile
      desktopTabOpen: "",
      discussionData: [ "Data things" ],
      discussionLoaded: false,
      trans
    };
  },

  watch: {
    desktopTabOpen(newVal) {
      this.mobileTabsOpen = [ newVal ];
    }
  },

  created() {
    this.desktopTabOpen = this.allTabs[0];
    this.mobileTabsOpen = [];

    this.fetchComments();
  },

  computed: {
    allTabs() {
      const arr = [];

      if (this.publications) {
        arr.push("publications");
      }

      if (this.notes) {
        arr.push("notes");
      }

      if (this.about) {
        arr.push("about");
      }

      arr.push("discussion");

      return arr;
    },
    hasAbout() {
      return this.allTabs.indexOf("about") !== -1;
    },
    hasNotes() {
      return this.allTabs.indexOf("notes") !== -1;
    },
    hasPublications() {
      return this.allTabs.indexOf("publications") !== -1;
    },
    discussionTitle() {
      return this.discussionLoaded && this.discussionData.response.length ?
        `${trans("Discussion")} (${this.discussionData.response.length})` :
        `${trans("Discussion")}`;
    }
  },

  methods: {
    fetchComments() {
      console.log("Fetching comments");
      $.get("/api/disqus", {
        endpoint: "/threads/listPosts.json",
        order: "asc",
        thread: `ident:manuscript/${this.manuscriptId}`
      })
        .done(data => {
          this.discussionData = data;
          this.discussionLoaded = true;
        })
        .fail(() => console.log("Failed to fetch comments data"));
    }
  },

  template: require("./templates/tablist.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/tablist.js